package songwritersnotebook.app.data

import kotlinx.serialization.Serializable
import com.benasher44.uuid.uuid4
import kotlinx.datetime.Clock

@Serializable
data class SavedProgression(
    val id: String = uuid4().toString(),
    val ownerId: String = "",
    val progression: ChordProgression,
    val dateAdded: Long = Clock.System.now().toEpochMilliseconds(),
    val isPublic: Boolean = false,
    val sharedWith: List<String> = emptyList() // List of UIDs
)
